module.exports = __webpack_public_path__ + "static/media/carfinder.ba382627.png";